import React from "react";
import { Box, Typography } from "@mui/material";
import PendingMatchesList from "../components/PendingMatchesList";

const PendingMatchesPage: React.FC = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Matches Pendentes
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Reveja e aprove matches sugeridos automaticamente.
        </Typography>
      </Box>
      <PendingMatchesList />
    </Box>
  );
};

export default PendingMatchesPage;
